<template>
  <div class="h-[80vh] py-5">
    <div class="px-4 py-0.5 pb-3 w-full flex items-center border-b border-gray-300">
      <h1 class="text-xl">{{ $t('confirmTheInfo') }}</h1>
    </div>

    <!-- <div v-if="isLoading" class="p-3 md:p-6 w-full h-full flex flex-col md:flex-row gap-4">
      <div
        class="basis-auto md:basis-1/3 aspect-video md:aspect-[9/12] p-2 bg-brand-gray-300 animate-pulse"
      ></div>
      <div class="basis-auto md:basis-2/3 md:p-2 flex flex-col gap-y-2.5 animate-pulse">
        <div
          :key="i"
          v-for="i in [1, 2, 3, 4, 5, 6, 7]"
          class="w-full flex justify-between gap-x-3"
        >
          <div class="basis-1/4 bg-brand-gray-300 p-4"></div>
          <div class="basis-3/4 bg-brand-gray-300 p-4"></div>
        </div>
      </div>
    </div> -->
    <div class="p-3 md:p-6 w-full flex flex-col md:flex-row gap-4 flex-1 h-full overflow-y-auto">
      <div
        :style="{ backgroundImage: `url(${scanBg4})` }"
        class="basis-auto md:basis-1/3 p-4 md:aspect-[9/12] w-full h-full flex justify-center items-center max-h-[32rem] bg-brand-black-secondary rounded-lg bg-center bg-cover relative"
      >
        <img
          :src="ocrStore.uploadedFile"
          alt="Uploaded EID/Passport"
          class="rounded-xl border-2 max-w-[32rem] w-full aspect-[16/11] border-blue-500 object-cover"
        />
        <div
          v-if="isLoading"
          :style="{ backgroundImage: `url(${scanAnimation})` }"
          class="absolute scan-animation top-0 start-0 w-full h-full rounded-lg bg-no-repeat bg-center"
        ></div>
      </div>

      <div
        v-if="isLoading"
        class="basis-auto md:basis-2/3 md:p-2 flex flex-col gap-y-2.5 animate-pulse"
      >
        <div
          :key="i"
          v-for="i in [1, 2, 3, 4, 5, 6, 7]"
          class="w-full flex justify-between gap-x-3"
        >
          <div class="basis-1/4 bg-brand-gray-300 p-4"></div>
          <div class="basis-3/4 bg-brand-gray-300 p-4"></div>
        </div>
      </div>

      <Form
        v-else
        :initial-values="mappedValues"
        ref="form"
        class="basis-auto md:basis-2/3 flex flex-col gap-y-1"
      >
        <Field
          v-if="fieldsToDisplay.includes('idNumber')"
          name="idNumber"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('idNumber')"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('cardNumber')"
          name="cardNumber"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('cardNumber')"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('passportNumber')"
          name="passportNumber"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('passportNumber')"
            :is-required="false"
            :max-length="80"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('passportType')"
          name="passportType"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('passportType')"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('countryCode')"
          name="countryCode"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('country')"
            :options="countries"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
            @on-selection="(item) => handleChange(+item?.code)"
          ></SimpleDropdown>
        </Field>

        <Field
          v-if="fieldsToDisplay.includes('nationality')"
          name="nationality"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('nationality')"
            :options="countries"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
            @on-selection="(item) => handleChange(+item?.code)"
          ></SimpleDropdown>
        </Field>

        <Field
          v-if="fieldsToDisplay.includes('nameEn')"
          name="nameEn"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('englishName')"
            :is-required="false"
            :max-length="100"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>

        <Field
          v-if="fieldsToDisplay.includes('gender')"
          name="gender"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('gender')"
            :options="genders"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
            @on-selection="(item) => handleChange(item?.code)"
          ></SimpleDropdown>
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('placeOfBirth')"
          name="placeOfBirth"
          v-slot="{ field, errors }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errors"
            :label="$t('EnglishPlaceOfBirth')"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('placeOfIssue')"
          name="placeOfIssue"
          v-slot="{ field, errors }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errors"
            :label="$t('passportIssuePlace')"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
          />
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('dateOfBirth')"
          name="dateOfBirth"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('dateOfBirth')"
            :default-value="field.value"
            label-class="text-xs"
            input-class="w-full text-xs"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('dateOfIssue')"
          name="dateOfIssue"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('dateOfBirth')"
            :default-value="field.value"
            label-class="text-xs"
            input-class="w-full text-xs"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
        <Field
          v-if="fieldsToDisplay.includes('dateOfExpiry')"
          name="dateOfExpiry"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('PassportExpiryDate')"
            :default-value="field.value"
            label-class="text-xs"
            input-class="w-full text-xs"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
      </Form>
    </div>

    <div class="px-4 w-full flex justify-end gap-x-4 items-center">
      <button
        class="px-1.5 rounded-md bg-gradient-to-tr from-gray-600 to-gray-300 text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        @click.prevent="$emit('onTransition', 'initial')"
      >
        <div class="flex justify-center items-center h-full p-1.5 rounded-s">
          <faTimes class="w-4 fill-white" />
        </div>
        <span class="px-1.5 ltr:font-sans tracking-wide text-sm pb-[1px]">
          {{ $t('camCancel') }}
        </span>
      </button>
      <button
        class="px-1.5 rounded-md bg-gradient-to-tr from-linear-s to-linear-e text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        type="submit"
        @click="handleSubmit"
      >
        <div class="flex justify-center items-center h-full p-2 rounded-s">
          <faCheck class="w-4 fill-white" />
        </div>
        <span class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
          {{ $t('confirmAndFillOut') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import faCheck from '@/assets/icons/faCheck.svg?component'
import faTimes from '@/assets/icons/faTimes.svg?component'
import scanBg4 from '@/assets/pngs/ocr_scan_effect_4.png'
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { useLookupsStore } from '@/stores/lookups'
import { useOcrStore } from '@/stores/ocr'
import { Field, Form } from 'vee-validate'
import { computed, onMounted, ref } from 'vue'
import { DateTime } from 'luxon'

const emit = defineEmits(['onTransition', 'onComplete'])

const ocrStore = useOcrStore()
const lookupsStore = useLookupsStore()
const isLoading = ref(true)
const genders = ref([])
const countries = ref([])
const form = ref()
const mappedValues = ref({})

const fieldsToDisplay = computed(() => {
  if (ocrStore.ocrType === 0) {
    return [
      'nameEn',
      'countryCode',
      'nationality',
      'gender',
      'dateOfBirth',
      'passportNumber',
      'dateOfExpiry'
    ]
  }

  return [
    'nameEn',
    'gender',
    'nationality',
    'dateOfBirth',
    'idNumber',
    'cardNumber',
    'dateOfExpiry'
  ]
})

onMounted(async () => {
  genders.value = await lookupsStore.fetchLookup('/api/lookup/genders')
  countries.value = await lookupsStore.fetchLookup('/api/lookup/countries')
  try {
    await ocrStore.uploadDocument()

    Object.assign(mappedValues.value, ocrStore.ocrResponse)

    const { countryCode, nationality, gender, dateOfBirth, dateOfExpiry } = ocrStore.ocrResponse

    /**
     * manually map dropdown fields
     */
    mappedValues.value.countryCode = countries.value.find(
      (c) => c.isoThreeCharactersCode == countryCode
    )?.code
    mappedValues.value.nationality = countries.value.find(
      (c) => c.isoThreeCharactersCode == nationality
    )?.id
    mappedValues.value.gender = gender == 'M' ? 1 : 0

    if (dateOfBirth) {
      mappedValues.value.dateOfBirth = DateTime.fromFormat(dateOfBirth, 'dd-MM-yyyy').toFormat(
        'dd/MM/yyyy'
      )
    }

    if (dateOfExpiry) {
      mappedValues.value.dateOfExpiry = DateTime.fromFormat(dateOfExpiry, 'dd-MM-yyyy').toFormat(
        'dd/MM/yyyy'
      )
    }
  } catch (error) {
    console.error(error)
    emit('onTransition', 'scanFailed')
  }

  isLoading.value = false
})

const handleSubmit = () => {
  emit('onComplete', form.value.values)
}
</script>

<style lang="scss" scoped>
.scan-animation::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: #03dac6;
  // box-shadow: 0 0 70px 20px rgba(14, 165, 233, 0.5);
  // box-shadow: 0 0 70px 20px theme('colors.sky.300');
  box-shadow: 0 0 70px 20px rgba(3, 218, 198, 0.5);
  clip-path: inset(0);
  animation:
    x 1.5s ease-in-out infinite alternate,
    y 3s ease-in-out infinite;
}

@keyframes x {
  to {
    transform: translateY(-100%);
    top: 100%;
  }
}

@keyframes y {
  33% {
    clip-path: inset(-100px 0 0 0);
  }
  50% {
    clip-path: inset(0 0 0 0);
  }
  83% {
    clip-path: inset(0 0 -100px 0);
  }
}
</style>
